<template>
	<div class="container-fluid">
	    <div class="m-2">
	    	<div class="row d-flex justify-content-center">
	    		<div class="col-12">
	    			<div class="row">
	    				<div class="col-12">
	    					<div class="alert alert-primary">
	    						<div class="h4 text-center">
	    							<linkto :link="'/categories'"/>
	    							Kategória módosítás
	    						</div>
	    					</div>
	    				</div>
	    			</div>
	    			<div class="row d-flex justify-content-center align-items-center">
	    				<catdata
	    					:change="true"
	    					:id="$route.params.id"
	    				>
	    				</catdata>
	    			</div>
	    		</div>
	    	</div>
	    </div>
	</div>
</template>

<script>
import catdata from './category_data'
export default {
  name: 'category',
  components: {
  	catdata
  },
  data () {
    return {
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/admin/categories/category.vue